import { KeyArrayMap } from "@merri/common";
import { SearchFilter, SearchFilterValue } from "src/app/shared";
import { DesignLayout } from "../models/design-layout";
import { DesignLayoutsSelectorTab } from "../models/design-layouts-selector-tab";

export interface GetDesignLayoutsFilterResponse {
  success: boolean;
  errors: string[];
  filters: DesignLayoutsFilterResponse[];
}

export interface DesignLayoutsFilterResponse {
  source: string;
  attributes: KeyArrayMap<string>;
}

export interface GetDesignLayoutsResponse {
  success: boolean;
  errors: string[];
  layouts: DesignLayoutResponse[];
  totalCount: number;
}

export interface PostDesignLayoutResponse {
  success: boolean;
  errors: string[];
  createdLayouts: KeyArrayMap<string>;
  addedVariantSkuIds: number[];
  failedLayouts: string[];
  invalidLayouts: string[];
  requiresItemSelection: boolean;
  maxThresholdReached: boolean;
  visionBoardId: number;
}

export interface DesignLayoutResponse {
  layoutId: string;
  layoutName: string;
  roomName: string;
  tableSeatCount: number;
  chairSeatCount: number;
  primaryImageUrl: string;
  thumbnailImageUrl: string;
  isTemplate: boolean;
  canActivateTemplate: boolean;
  canEditLayoutName: boolean;
  eventId: number;
  designId: number;
  eventVenueLinked: boolean;
}

export interface PostDesignLayoutTemplateActiveResponse {
  success: boolean;
  canActivateTemplate: boolean;
  errors: string[];
}

export class DesignLayoutsSelectorResponses {
  static getDesignLayoutSelectorTabs(response: GetDesignLayoutsFilterResponse): DesignLayoutsSelectorTab[] {
    return response && response.filters ? response.filters.map(i => DesignLayoutsSelectorResponses.getDesignLayoutSelectorTab(i)) : [];
  }

  static getDesignLayoutSelectorTab(response: DesignLayoutsFilterResponse): DesignLayoutsSelectorTab {
    if (!response) return null;

    const tab = new DesignLayoutsSelectorTab();

    tab.name = response.source;
    tab.attributes = DesignLayoutsSelectorResponses.getDesignLayoutFilters(response);

    return tab;
  }

  static getDesignLayoutFilters(response: DesignLayoutsFilterResponse): SearchFilter[] {
    if (!response) {
      return null;
    }

    const searchFilters: SearchFilter[] = [];

    Object.keys(response.attributes).forEach(attribute => {
      const searchFilter = new SearchFilter();
      searchFilter.values = [];
      searchFilter.name = attribute;
      response.attributes[attribute].forEach(val => {
        searchFilter.values.push(new SearchFilterValue(val));
      });

      searchFilters.push(searchFilter);
    });

    return searchFilters;
  }

  static getDesignLayouts(response: GetDesignLayoutsResponse): DesignLayout[] {
    return response && response.layouts ? response.layouts.map(i => DesignLayoutsSelectorResponses.getDesignLayout(i)) : [];
  }

  static getDesignLayout(response: DesignLayoutResponse): DesignLayout {
    if (!response) return null;

    return {
      layoutId: response.layoutId,
      layoutName: response.layoutName,
      roomName: response.roomName,
      tableSeatCount: response.tableSeatCount,
      chairSeatCount: response.chairSeatCount,
      primaryImageUrl: response.primaryImageUrl,
      thumbnailImageUrl: response.thumbnailImageUrl,
      isTemplate: response.isTemplate,
      canActivateTemplate: response.canActivateTemplate,
      canEditLayoutName: response.canEditLayoutName,
      designId: response.designId,
      eventId: response.eventId,
      eventVenueLinked: response.eventVenueLinked,
    };
  }
}
